import { render, staticRenderFns } from "./SearchResultMessagesList.vue?vue&type=template&id=96fb2a4c&"
import script from "./SearchResultMessagesList.vue?vue&type=script&lang=js&"
export * from "./SearchResultMessagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96fb2a4c')) {
      api.createRecord('96fb2a4c', component.options)
    } else {
      api.reload('96fb2a4c', component.options)
    }
    module.hot.accept("./SearchResultMessagesList.vue?vue&type=template&id=96fb2a4c&", function () {
      api.rerender('96fb2a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchResultMessagesList.vue"
export default component.exports